var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_648_46276",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_231_648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.4 0L0.400024 0V25H25.4V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_648_46276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 4.20561C11.9967 4.20561 11.2645 4.93785 11.2645 5.84113H7.0589C7.0589 2.61516 9.67406 0 12.9 0C16.126 0 18.7411 2.61516 18.7411 5.84113C18.7411 9.06709 16.126 11.6822 12.9 11.6822V7.47664C13.8033 7.47664 14.5355 6.74439 14.5355 5.84113C14.5355 4.93785 13.8033 4.20561 12.9 4.20561ZM21.1944 12.5C21.1944 11.5967 20.4621 10.8645 19.5589 10.8645V6.65887C22.7849 6.65887 25.4 9.27404 25.4 12.5C25.4 15.726 22.7849 18.3411 19.5589 18.3411C16.3329 18.3411 13.7178 15.726 13.7178 12.5H17.9234C17.9234 13.4032 18.6556 14.1355 19.5589 14.1355C20.4621 14.1355 21.1944 13.4032 21.1944 12.5ZM6.24115 14.1355C5.33787 14.1355 4.60564 13.4032 4.60564 12.5C4.60564 11.5967 5.33787 10.8645 6.24115 10.8645C7.14441 10.8645 7.87666 11.5967 7.87666 12.5H12.0823C12.0823 9.27404 9.46711 6.65887 6.24115 6.65887C3.01519 6.65887 0.400024 9.27404 0.400024 12.5C0.400024 15.726 3.01519 18.3411 6.24115 18.3411V14.1355ZM12.9 20.7944C13.8033 20.7944 14.5355 20.0621 14.5355 19.1589H18.7411C18.7411 22.3849 16.126 25 12.9 25C9.67406 25 7.0589 22.3849 7.0589 19.1589C7.0589 15.9329 9.67406 13.3177 12.9 13.3177V17.5234C11.9967 17.5234 11.2645 18.2556 11.2645 19.1589C11.2645 20.0621 11.9967 20.7944 12.9 20.7944Z",
    fill: "#F0F0DC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudService);
export default __webpack_public_path__ + "static/media/cloud_service.dbcdc3ed6fae76f5f6c257ebcbf13903.svg";
export { ForwardRef as ReactComponent };